import { ExtraOptions, Route, PreloadingStrategy } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
// export class CustomPreloadingStrategy implements PreloadingStrategy  {
//
// preload(route: Route, fn: () => Observable<boolean>):Observable<boolean> {
//  return of(true).delay(5000).flatMap( (_:boolean)=>fn());
//  }
//
// }

// export class PreloadSelectedModules implements PreloadingStrategy {
//  preload(route: Route, load: Function): Observable<any> {
//     return route.data && route.data.preload ? load() : of(null);
//   }
// }


export class AppPreloadingStrategy implements PreloadingStrategy {
    preload(route: Route, load: Function): Observable<any> {
        const loadRoute = (delay) => delay
            ? timer(5000).pipe(mergeMap(_ => load()))
            : load();
        return route.data && route.data.preload
            ? loadRoute(route.data.delay)
            : of(null);
    }
}
